import React, { memo } from "react";

import SurveyPreview from "../SurveyPreview";
import OfferPreview from "../OfferPreview";
import CustomPostPreview from "../CustomPostPreview";
import { SurfaceDimensionsContext } from "../../SurfaceManager";

import GET from "../../../utils/GET";

const platform = GET("platform");
const customOfferPreview = GET("customOfferPreview");
const customSurveyPreview = GET("customSurveyPreview");
const customPostPreview = GET("customPostPreview");

const ModulesPreview = memo(({ innerHeight, offsetTop }) => {
	if (!platform) {
		return null;
	}

	return (
		<SurfaceDimensionsContext.Provider
			value={{
				innerHeight: Number(innerHeight),
				offsetTop: Number(offsetTop),
			}}
		>
			{customSurveyPreview && <SurveyPreview />}
			{customOfferPreview && <OfferPreview />}
			{customPostPreview && <CustomPostPreview />}
		</SurfaceDimensionsContext.Provider>
	);
});

export default ModulesPreview;
